export const translations = {
  fr: {
    // Navigation
    home: 'Accueil',
    about: 'À Propos',
    services: 'Services',
    products: 'Produits',
    markets: 'Marchés',
    partners: 'Partenaires',
    contact: 'Contact',
    
    // Hero Section
    heroTitle: 'TECHYID',
    heroSubtitle: "LEADER DE DISTIBUTION DE MATERIEL ELECTRIQUE EN MAURITANIE",
    heroDescription: "",
    ctaButton: 'Découvrir Nos Services',
    scrollText: 'Défiler vers le bas',
    
    // About Section
    aboutTitle: 'À Propos',
    aboutSubtitle: 'Découvrez TECHYID, votre partenaire de confiance',
    semiFiliale: 'Semi-filiale du groupe AON',
    techyid: 'TECHYID',
    
    // Discover Products Section
    discoverProductsTitle: 'Découvrez nos produits',
    viewAllProducts: 'Voir tous les produits',
    
    // About Section Features
    aboutFeatures: {
      whoWeAre: [
        'Expertise technique reconnue',
        'Produits de qualité supérieure',
        'Service client exceptionnel',
        'Support technique complet'
      ],
      history: [
        'Fondation de l\'entreprise',
        'Développement et croissance',
        'Partenariats stratégiques',
        'Innovation continue'
      ],
      positioning: [
        'Leader du marché local et régional',
        'Expansion continentale',
        'Vision d\'avenir',
        'Excellence opérationnelle'
      ],
      mission: [
        'Durabilité : des solutions respectueuses de l\'environnement.',
        'Innovation : technologies de pointe pour demain.',
        'Formation : renforcer les compétences et le savoir-faire.',
        'Impact social : améliorer concrètement la vie des communautés.'
      ]
    },
        aboutDescription1: "TECHYID, Semi-filiale du groupe AON, est le leader mauritanien dans la distribution d'équipements électriques pour le bâtiment, l'industrie, les infrastructures et les hôpitaux. Notre mission : offrir à nos clients des solutions fiables, innovantes et durables qui répondent aux standards internationaux les plus exigeants.",
        aboutDescription2: "Grâce à notre équipe d'experts techniques et commerciaux, nous travaillons main dans la main avec les plus grands fabricants européens pour garantir des produits de qualité supérieure, alliant performance, sécurité et efficacité énergétique. Chez TECHYID, nous faisons plus que distribuer du matériel électrique : nous accompagnons vos projets de bout en bout pour construire l'avenir énergétique de la Mauritanie et de l'Afrique.",
    aboutImageAlt: 'À propos de TECHYID',
    
    // About Section Tabs
    aboutTabs: {
      whoWeAre: 'Qui Sommes Nous ?',
      history: 'Historique',
      positioning: 'Positionnement',
      values: 'Nos Valeurs',
      productLegend: 'Légende des familles de produits',
      keyMarkets: 'Trois Marchés-Clés',
      advantages: 'Que des avantages...',
      mission: 'Notre Mission',
      location: 'Siège Social'
    },
    
    aboutContent: {
      whoWeAre: {
        title: 'Qui Sommes Nous ?',
        content1: 'TECHYID, Semi-filiale du groupe AON, est le leader mauritanien dans la distribution d\'équipements électriques pour le bâtiment, l\'industrie, les infrastructures et les hôpitaux.',
        content2: 'Notre mission : offrir à nos clients des solutions fiables, innovantes et durables qui répondent aux standards internationaux les plus exigeants.',
        content3: 'Grâce à notre équipe d\'experts techniques et commerciaux, nous travaillons main dans la main avec les plus grands fabricants européens pour garantir des produits de qualité supérieure, alliant performance, sécurité et efficacité énergétique.',
        content4: 'Chez TECHYID, nous faisons plus que distribuer du matériel électrique : nous accompagnons vos projets de bout en bout pour construire l\'avenir énergétique de la Mauritanie et de l\'Afrique.'
      },
      history: {
        title: 'Historique',
        content1: 'Depuis sa création, TECHYID s\'est imposée comme un acteur de référence dans le secteur électrique en Mauritanie et dans la région. Animée par une vision claire et une volonté d\'innovation, l\'entreprise a su évoluer au rythme des besoins du marché et des avancées technologiques.',
        content2: 'Notre parcours est jalonné de projets ambitieux, de partenariats stratégiques et d\'un engagement constant en faveur de la qualité et de l\'excellence. Grâce à notre expertise et à notre capacité d\'adaptation, nous accompagnons nos clients dans la réalisation de solutions électriques fiables, modernes et durables.'
      },
      positioning: {
        title: 'Positionnement Stratégique',
        content1: 'Nous nous positionnons comme le leader du marché de la distribution de matériel électrique en Mauritanie, avec une ambition affirmée d\'étendre notre influence à l\'échelle du continent africain. Grâce à une offre complète et innovante, nous apportons des solutions fiables et durables pour relever les défis énergétiques de l\'Afrique et accompagner sa croissance.'
      },
      values: {
        title: 'Nos Valeurs',
        content1: 'Chez nous, chaque décision, chaque action, est guidée par des valeurs fortes. Elles incarnent notre quête d\'excellence, notre intégrité et notre engagement à offrir une expérience client exceptionnelle. Avec ces principes au cœur de tout ce que nous faisons, nous construisons des relations durables et faisons la différence, jour après jour.'
      },
      productLegend: {
        title: 'Légende des familles de produits',
        intro: 'TECHYID offre à sa clientèle une gamme complète de produits et services, complétée par des prestations d\'ingénierie et techniques, afin de s\'imposer comme un partenaire de choix à forte valeur ajoutée.',
        electricity: {
          title: '1. Électricité',
          subtitle: 'Produits et équipements pour le secteur électrique :',
          items: [
            'Câbles, connexion, terminaison et jonction',
            'Goulottes, conduits et accessoires',
            'Électroménager',
            'Éclairage et sources',
            'Matériel industriel',
            'Matériel basse tension',
            'Sécurité, détection incendie et parafoudres',
            'Instrumentation, mesure et régulation',
            'Matériel de poste et matériel de ligne',
            'Groupes électrogènes',
            'Chargeurs de batteries',
            'Armoires et coffrets informatiques',
            'Systèmes courants faibles'
          ]
        },
        industry: {
          title: '2. Industrie',
          subtitle: 'Matériel et équipement pour les secteurs industriels :',
          items: [
            'Mines',
            'Pétrole et gaz',
            'Électrique',
            'Chimique',
            'Agroalimentaire',
            'Briqueteries',
            'Cimenteries'
          ]
        },
        building: {
          title: '3. Bâtiment',
          subtitle: 'Matériel et équipement pour la construction et le bâtiment :',
          items: [
            'Étanchéité',
            'Plâtre',
            'Carrelage',
            'Bardage',
            'Sanitaire',
            'Robinetterie',
            'Tôles, aciers et tubes',
            'Portes'
          ]
        },
        infrastructure: {
          title: '4. Infrastructure',
          subtitle: 'Matériel et équipement pour les infrastructures :',
          items: [
            'Électrification et électrification rurale',
            'Aéroports',
            'Ports',
            'Chemins de fer',
            'Hydraulique',
            'Télécom'
          ]
        }
      },
      keyMarkets: {
        title: 'Trois Marchés-Clés',
        building: {
          title: 'Bâtiment & Tertiaire',
          content: 'Du logement économique au bâtiment haut de gamme, en passant par les écoles, nous accompagnons nos clients à chaque étape, en apportant fiabilité, rapidité et optimisation des coûts.'
        },
        industry: {
          title: 'Industrie',
          content: 'Qu\'il s\'agisse d\'usines, de plateformes minières ou de sites industriels, TECHYID assure la disponibilité des matériaux et équipements adaptés, en s\'appuyant sur des partenariats solides avec les leaders mondiaux, pour garantir qualité et performance.'
        },
        infrastructure: {
          title: 'Infrastructure',
          content: 'Électricité, télécom, transport, santé ou installations sportives… Nous fournissons des solutions robustes et durables, capables de répondre aux exigences les plus élevées et de concrétiser vos ambitions.'
        },
        conclusion: 'TECHYID, plus qu\'un fournisseur, un partenaire qui transforme vos projets en succès.'
      },
      advantages: {
        title: 'Que des avantages...',
        subtitle: 'Découvrez les nombreux avantages qui font de TECHYID votre partenaire de confiance pour tous vos projets électriques',
        items: [
          {
            title: '💰 Économies d\'Échelle',
            content: 'Des prix compétitifs négociés au niveau national et international pour vous assurer un maximum de profit'
          },
          {
            title: '🛡️ Sécurité d\'Approvisionnement',
            content: 'Garantie de qualité et de disponibilité des produits grâce à nos partenariats privilégiés'
          },
          {
            title: '🎯 Savoir-Faire TECHYID',
            content: 'Expertise technique reconnue et expérience approfondie dans le domaine électrique'
          },
          {
            title: '🌍 Partenariats Mondiaux',
            content: 'Collaboration avec les plus grands fabricants mondiaux pour des produits de qualité supérieure'
          },
          {
            title: '⚡ Disponibilité Immédiate',
            content: 'Mise en disponibilité rapide des produits pour respecter vos délais de projet'
          },
          {
            title: '📋 Assistance Marchés',
            content: 'Support complet pour la soumission à des marchés publics et privés'
          }
        ]
      },
      mission: {
        title: 'Notre Mission',
        content1: 'Offrir des solutions électriques fiables et innovantes qui soutiennent le développement durable et génèrent un impact positif pour nos partenaires et les communautés.',
        valuesTitle: 'Nos valeurs :',
        values: [
          {
            title: 'Durabilité',
            content: 'des solutions respectueuses de l\'environnement.'
          },
          {
            title: 'Innovation',
            content: 'technologies de pointe pour demain.'
          },
          {
            title: 'Formation',
            content: 'renforcer les compétences et le savoir-faire.'
          },
          {
            title: 'Impact social',
            content: 'améliorer concrètement la vie des communautés.'
          }
        ]
      },
      location: {
        title: 'Siège Social',
        content1: 'TECHYID est située au cœur de Nouakchott, dans le quartier de Tevragh Zeina, Cité plage, lot 41.',
        mapButton: '▶ Ouvrir dans Google Maps'
      }
    },
    
    // Services Section
    servicesTitle: 'Nos Services',
    servicesSubtitle: 'Une Offre Globale',
    service1: "Monitoring",
    service1Desc: "Surveillance et contrôle en temps réel de vos installations électriques",
    service2: "Installations et Mise en Service",
    service2Desc: "Installation professionnelle et mise en service de vos équipements électriques",
    service3: "Maintenance",
    service3Desc: "Maintenance préventive et corrective pour assurer la fiabilité de vos installations",
    service4: "Offre Solaire",
    service4Desc: "Solutions solaires photovoltaïques pour un avenir énergétique durable",
    
    // Products Section
    productsTitle: 'Nos Produits',
    productsSubtitle: 'Matériel et Équipement',
    productCategory1: 'Matériel & Équipement de Distribution Électrique',
    productCategory2: 'Groupes Électriques',
    productCategory3: 'Accessoires Électriques',
    learnMore: 'En savoir plus',
    sending: 'Envoi en cours...',
    
    // All Products Page
    allProducts: 'Tous les Produits',
    allProductsSubtitle: 'Découvrez notre gamme complète de produits et solutions électriques',
    backToHome: "Retour à l'accueil",
    searchProducts: 'Rechercher des produits...',
    allCategories: 'Toutes les catégories',
    noProductsFound: 'Aucun produit trouvé',
    noProductsFoundText: "Essayez d'ajuster vos critères de recherche ou de filtrage",
    viewDetails: 'Voir les détails',
    seeAllProducts: 'Voir tous les produits',
    
    // Catalog Page
    catalogTitle: 'Catalogue produits',
    viewAllProductsCatalog: 'Voir tous les produits',
    product: 'Produit',
    
    // Cable Categories
    cableTransportTitle: 'Câbles de transport et de distribution de l\'énergie',
    cableBuildingsTitle: 'Câbles de bâtiments',
    transformersTitle: 'Transformateurs',
    switchgearTitle: 'Cellules HTA',
    
    // Other Categories
    prefabricatedSubstationsTitle: 'Postes préfabriqués',
    generatorsTitle: 'Groupes Électrogènes',
    electricalEquipmentTitle: 'Matériel Électrique',
    publicLightingTitle: 'Éclairage Public',
    
    // Cable Subcategories
    mediumVoltageCablesTitle: 'Câbles moyenne tension',
    overheadLinesTitle: 'Lignes aériennes à conducteurs nus',
    aaacConductorsTitle: 'Conducteurs en alliage d\'aluminium (AAAC)',
    lowVoltageCablesTitle: 'Câbles basse tension',
    
    // Building Cable Subcategories
    standardCables1kvTitle: 'Fils et câbles standard 1kV',
    standardCablesLt1kvTitle: 'Fils et câbles standard <1kV',
    specialCablesTitle: 'Câbles spéciaux',
    armouredCablesTitle: 'Câbles armés',
    
    // Switchgear
    fluocellSwitchgearTitle: 'Cellules Fluocell',
    
    // Lighting Categories
    functionalLightingTitle: 'Gamme d\'éclairage Fonctionnel',
    decorativeLightingTitle: 'Gamme d\'éclairage décoratif',
    signageSupportsTitle: 'Supports de signalisation',
    sportsLightingTitle: 'Gamme d\'éclairage sportif et grands espaces',
    
    // Common UI Text
    loadingProducts: 'Chargement des produits...',
    loadingSubcategories: 'Chargement des sous-catégories...',
    loadingEnsembles: 'Chargement des ensembles...',
    loadingSubcategoriesLighting: 'Chargement des sous-catégories d\'éclairage public...',
    loadingProduct: 'Chargement du produit...',
    loading: 'Chargement...',
    subcategoryNotFound: 'Sous-catégorie non trouvée',
    subcategory: 'Sous-catégorie',
    productsAvailable: 'Produits disponibles:',
    productsPlural: 'produits',
    productSingular: 'produit',
    families: 'families',
    
    // Empty States
    noRangesAvailable: 'Aucune gamme disponible',
    rangesComingSoon: 'Les gammes d\'éclairage public seront bientôt disponibles. Contactez-nous pour plus d\'informations.',
    ourLightingRanges: 'Nos Gammes d\'Éclairage',
    discoverEnsembles: 'Découvrir les ensembles',
    
    // Installation Service Page
    installationServiceTitle: 'Installation & Mise en Service',
    installationServiceSubtitle: 'Solution Complète d\'Installation et Mise en Service',
    installationServiceIntro: 'à travers son partenariat en Mauritanie, s\'engage à fournir des systèmes et des services répondant aux besoins et aux objectifs de développement durable de ses partenaires.',
    installationServiceKeyActor: 'En tant qu\'acteur clé dans la distribution de matériel électrique, TECHYID se distingue par :',
    installationServiceExpertise: 'une expertise en approvisionnement fiable et rapide,',
    installationServiceInterfaces: 'des interfaces techniques adaptées,',
    installationServiceTesting: 'des essais et une mise en service de qualité,',
    installationServiceIntegration: 'une intégration complète et des solutions vérifiées de bout en bout,',
    installationServiceQuality: 'garantissant un haut niveau de qualité et de fiabilité.',
    installationServiceComprehensive: 'comprend tout ce dont ses clients ont besoin pour la mise en place de leurs projets : logiciels, matériel, et services d\'accompagnement, avec une approche axée sur l\'efficacité et la réussite à long terme.',
    installationServiceRange: 'TECHYID propose une gamme complète de services d\'installation et de mise en service pour répondre à tous vos besoins :',
    constructionInstallation: 'Construction & Installation',
    constructionInstallationDesc: 'Un acteur de premier plan dans les secteurs de l\'énergie et des télécommunications, une entreprise de référence pour des services de construction et d\'installation exceptionnels.',
    commissioning: 'Commissioning (Mise en service)',
    commissioningDesc: 'Management & Consultancy pour assurer une mise en service optimale de vos installations.',
    electricalTesting: 'Electrical Testing & Commissioning',
    electricalTestingDesc: 'Nous trouverons la solution fiable et adaptée à vos besoins en alimentation électrique.',
    instrumentation: 'Instrumentation',
    instrumentationDesc: 'Nous proposons des services d\'essai et de mise en service d\'instruments pour garantir la précision et la fiabilité de vos équipements.',
    telecomIntegration: 'Telecom & System Integration',
    telecomIntegrationDesc: 'Intégration des systèmes ELV & Telecom pour une connectivité et une communication optimales.',
    
    // Solaire Page
    solairePageTitle: 'Offre Solaire',
    solairePageSubtitle: 'Solutions d\'énergie solaire photovoltaïque pour un avenir durable.',
    solairePageBreadcrumbServices: 'Services',
    solairePageBreadcrumbSolaire: 'Offre Solaire',
    solairePageContentTitle: 'L\'énergie solaire photovoltaïque',
    solairePageContent1: 'L\'énergie solaire photovoltaïque connaît une croissance rapide, tout comme l\'énergie éolienne, à l\'échelle mondiale. Cependant, pour atteindre le "Net-Zero" émission d\'ici 2050, il est impératif d\'accélérer le rythme.',
    solairePageContent2: 'Cela implique non seulement la multiplication des grands parcs solaires au sol, mais également l\'installation de panneaux solaires sur les toits des parkings, des bâtiments commerciaux et industriels, ainsi que des maisons individuelles.',
    solairePageContent3: 'Il est nécessaire d\'augmenter de sept fois, nos performances actuelles en énergie solaire photovoltaïque, au cours des dix prochaines années, et ce, pour répondre à une demande en forte croissance.',
    solairePageContent4: 's\'inscrit comme le partenaire de choix pour accompagner et accélérer la réalisation de ces projets à travers sa proposition de valeur.',
    solairePageDocumentationTitle: 'Documentation Technique',
    solairePageCatalogueTitle: 'Catalogue Offre Solaire',
    
    // Monitoring Page
    monitoringPageTitle: 'Monitoring MT et BT',
    monitoringPageSubtitle: 'Solutions pour le monitoring des postes de distribution MT / BT.',
    monitoringPageContent1: 'fournit des équipements destinés à la surveillance des postes de distribution MT/BT, qu\'ils soient souterrains ou aériens. Ces solutions sont multifonctionnelles, modulables et communicantes ont un rôle clé dans le fonctionnement des Smart Grids (réseaux intelligents). Elles permettent par exemple de surveiller plusieurs départs BT afin d\'obtenir un meilleur équilibre des charges.',
    monitoringPageContent2: 'La température du transformateur peut aussi être monitorée, une alarme SMS envoyée en cas de dépassement d\'un seuil configurable. Ces solutions peuvent aussi être utilisées pour rendre d\'autres appareils communicants, typiquement un Détecteur de Défauts autonome peut être connecté à ces équipements, ce qui va permettre d\'envoyer l\'information à distance.',
    monitoringPageProviderText: 'Solutions fournies en partenariat avec',
    monitoringPageCahorsAlt: 'CAHORS',
    
    // Product Details
    productDetails: {
      parafoudre: {
        title: 'Parafoudre',
        description: 'Protection contre les surtensions pour vos installations électriques',
        features: ['Protection contre la foudre', 'Installation facile', 'Haute durabilité']
      },
      'cable-bt': {
        title: 'Câble Basse Tension',
        description: 'Câbles électriques pour installations basse tension',
        features: ['Isolation de qualité', 'Flexibilité', 'Résistance aux intempéries']
      },
      'cable-mt': {
        title: 'Câble Moyenne Tension',
        description: 'Câbles pour installations moyenne tension',
        features: ['Haute résistance', 'Isolation renforcée', 'Certification internationale']
      },
      'cable-ht': {
        title: 'Câble Haute Tension',
        description: 'Câbles pour installations haute tension',
        features: ['Performance élevée', 'Sécurité maximale', 'Conformité aux normes']
      },
      transformateur: {
        title: 'Transformateur',
        description: 'Transformateurs électriques pour distribution d\'énergie',
        features: ['Efficacité énergétique', 'Maintenance facile', 'Longue durée de vie']
      },
      'poste-electrique': {
        title: 'Poste Électrique',
        description: 'Postes de transformation électrique complets',
        features: ['Installation clé en main', 'Sécurité optimale', 'Conformité réglementaire']
      },
      'groupe-electrogene': {
        title: 'Groupe Électrogène',
        description: 'Groupes électrogènes pour alimentation de secours',
        features: ['Démarrage automatique', 'Consommation optimisée', 'Maintenance simplifiée']
      },
      'cellule-arrive-depart': {
        title: 'Cellule Arrivée Départ',
        description: 'Cellules de distribution électrique',
        features: ['Compacte et robuste', 'Installation facile', 'Sécurité renforcée']
      },
      'ensemble-ancrage-70-40': {
        title: 'Ensemble d\'Ancrage 70/40',
        description: 'Ensembles d\'ancrage renforcés pour lignes électriques',
        features: ['Haute résistance', 'Installation sécurisée', 'Longue durée de vie']
      },
      'ensemble-suspension': {
        title: 'Ensemble de Suspension',
        description: 'Ensembles de suspension pour lignes électriques',
        features: ['Stabilité optimale', 'Résistance aux intempéries', 'Installation facile']
      },
      'ensemble-suspension-2': {
        title: 'Ensemble de Suspension',
        description: 'Ensembles de suspension pour lignes électriques',
        features: ['Stabilité optimale', 'Résistance aux intempéries', 'Installation facile']
      },
      'ensemble-suspension-3': {
        title: 'Ensemble de Suspension',
        description: 'Ensembles de suspension pour lignes électriques',
        features: ['Stabilité optimale', 'Résistance aux intempéries', 'Installation facile']
      },
      'iacm-50': {
        title: 'IACM 50',
        description: 'Interrupteur Automatique de Coupure Manuelle 50A',
        features: ['Protection automatique', 'Coupure manuelle', 'Haute fiabilité']
      },
      'iacm-100': {
        title: 'IACM 100',
        description: 'Interrupteur Automatique de Coupure Manuelle 100A',
        features: ['Protection renforcée', 'Coupure manuelle', 'Performance élevée']
      }
    },
    
    // Product Detail Page
    backToProducts: '← Retour aux produits',
    suppliedBy: 'Fourni par',
    mainFeatures: '✓ Caractéristiques principales',
    technicalSpecs: '⚙️ Spécifications techniques',
    productNotFound: 'Produit non trouvé',
    productNotFoundDesc: 'Le produit demandé n\'existe pas.',
    interestedInProduct: 'Intéressé par ce produit ?',
    contactForQuote: 'Contactez-nous pour obtenir un devis personnalisé et des conseils techniques',
    requestQuote: 'Demander un devis',
    
    // Specification Labels
    nominalVoltage: 'Tension nominale',
    dischargeCurrent: 'Courant de décharge',
    responseTime: 'Temps de réponse',
    temperature: 'Température',
    certification: 'Certification',
    power: 'Puissance',
    primaryVoltage: 'Tension primaire',
    secondaryVoltage: 'Tension secondaire',
    efficiency: 'Rendement',
    fuel: 'Carburant',
    voltage: 'Tension',
    current: 'Courant',
    type: 'Type',
    protection: 'Protection',
    charge: 'Charge',
    material: 'Matériau',
    diameter: 'Diamètre',
    length: 'Longueur',
    
    // Markets Section
    marketsTitle: 'Nos Marchés',
    marketsSubtitle: 'Secteurs d\'Activité',
    market1: 'Bâtiment & Tertiaire',
    market1Desc: 'Solutions électriques pour le secteur du bâtiment et tertiaire',
    market2: 'Industrie',
    market2Desc: 'Équipements industriels et solutions techniques spécialisées',
    market3: 'Infrastructure',
    market3Desc: 'Matériaux et équipements pour les projets d\'infrastructure',
    
    // Market Features
    marketFeatures: {
      building: ['Logements', 'Écoles', 'Bureaux', 'Commerce'],
      industry: ['Mines', 'Pétrole', 'Agroalimentaire', 'Maintenance'],
      infrastructure: ['Électrification', 'Télécom', 'Transport', 'Énergie']
    },
    
    // Partners Section
    partnersTitle: 'Nos Partenaires',
    partnersSubtitle: 'Des partenaires de confiance pour des solutions d\'excellence',
    partnersDescription: 'TECHYID collabore avec les plus grands fabricants mondiaux pour vous offrir des produits de qualité supérieure et des solutions innovantes.',
    trustTitle: 'Des Partenaires de Confiance',
    trustDescription: 'Grâce à nos partenariats privilégiés avec les leaders mondiaux de l\'industrie, nous vous garantissons des produits de qualité supérieure, des prix compétitifs et un support technique de premier plan.',
    trustedClientsTitle: 'Ils nous ont fait confiance',
    
    // Partner Details
    partnerDetails: {
      nexans: {
        name: 'Nexans',
        description: 'Câbles et solutions de connectivité'
      },
      deutz: {
        name: 'DEUTZ',
        description: 'Moteurs et générateurs de haute qualité'
      },
      ines: {
        name: 'Ines Max',
        description: 'Solutions électriques et de sécurité'
      },
      cahors: {
        name: 'CAHORS',
        description: 'Équipements électriques et de distribution'
      },
      ifamel: {
        name: 'IFAMEL',
        description: 'Équipements électriques et solutions industrielles'
      },
      marcont: {
        name: 'Marcont',
        description: 'Solutions électriques et équipements industriels'
      }
    },
    
    // Advantages Section
    advantagesTitle: 'Nos Avantages',
    advantagesSubtitle: 'Découvrez les avantages qui nous distinguent',
    advantage1: 'Savoir-faire particulier TECHYID',
    advantage2: 'Sécurité en termes de qualité d\'approvisionnement',
    advantage3: 'Mise en disponibilité des produits',
    advantage4: 'Partenariats avec des grands fabricants mondiaux',
    advantage5: 'Économies d\'échelle à travers des prix compétitifs',
    advantage6: 'Échanges d\'expériences',
    advantage7: 'Assistance technique gratuite',
    advantage8: 'Assistance pour la soumission à des marchés',
    
    // Advantages Array (for Markets component)
    advantages: [
      'Économies d\'échelle à travers des prix compétitifs',
      'Sécurité en termes de qualité d\'approvisionnement',
      'Savoir-faire particulier TECHYID',
      'Partenariats avec des grands fabricants mondiaux',
      'Mise en disponibilité des produits',
      'Assistance technique gratuite',
      'Assistance pour la soumission à des marchés',
      'Échanges d\'expériences'
    ],
    
    // Contact Section
    contactTitle: 'Contactez-nous',
    contactSubtitle: 'Nous sommes à votre écoute',
    address: 'Tevragh Zeina, Cité plage, lot 41 Nouakchott, Mauritanie',
    phone: '+222 48 61 06 89',
    email: 'contact@techyid.com',
    contactForm: {
      name: 'Nom',
      email: 'Email',
      subject: 'Sujet',
      message: 'Message',
      send: 'Envoyer',
    },
    locationTitle: 'Notre Localisation',
    locationDescription: 'Situés au cœur de Nouakchott, nous sommes facilement accessibles et à votre disposition pour tous vos besoins en équipements électriques et solutions industrielles.',
    messageSent: 'Message envoyé avec succès !',
    
    // Footer
    footerText: '© 2026 TECHYID. Tous droits réservés.',
    developerCredit: 'Développé par Overcode.dev',
    slogan: 'Leader de distribution de materiel electrique en Mauritanie',
    footerContact: 'Contact',
    followUs: 'Suivez-nous',
    workingHours: 'Lun - Vendredi : 08h00 - 17h00',
    
    // Admin Dashboard
    admin: {
      title: "Administration",
      overview: "Vue d'ensemble",
      dashboard: "Tableau de bord",
      totalProducts: "Total Produits",
      activeMarkets: "Marchés Actifs",
      partners: "Partenaires",
      globalReach: "Portée Mondiale",
      dashboardOverview: "Vue d'ensemble du tableau de bord"
    },

    // Login Page
    login: {
      title: "Connexion Admin",
      subtitle: "Connectez-vous à votre espace d'administration",
      emailLabel: "Adresse e-mail",
      passwordLabel: "Mot de passe",
      emailPlaceholder: "Entrez votre adresse e-mail",
      passwordPlaceholder: "Entrez votre mot de passe",
      loginButton: "Se connecter",
      loggingIn: "Connexion en cours...",
      invalidCredentials: "Identifiants invalides",
      loginError: "Erreur de connexion. Veuillez réessayer."
    },

    // Language Names
    languages: {
      en: "Anglais",
      fr: "Français",
      ar: "العربية"
    },

    // Alt Texts and Labels
    altTexts: {
      logo: "TECHYID",
      location: "Localisation",
      phone: "WhatsApp",
      email: "E-mail",
      time: "Heures",
      facebook: "Facebook",
      scrollToTop: "Retour en haut"
    },

    // Accessibility Labels
    accessibility: {
      toggleMobileMenu: "Basculer le menu mobile",
      hidePassword: "Masquer le mot de passe",
      showPassword: "Afficher le mot de passe",
      noDate: "Aucune date"
    },

    // Statistics
    statistics: {
      yearsExperience: "Années d'expérience",
      projectsCompleted: "Projets terminés",
      trustedPartners: "Partenaires de confiance",
      clientSatisfaction: "Satisfaction client"
    },
    showMore: "Afficher plus",
  },
  
  en: {
    // Navigation
    home: 'Home',
    about: 'About',
    services: 'Services',
    products: 'Products',
    markets: 'Markets',
    partners: 'Partners',
    contact: 'Contact',
    
    // Hero Section
    heroTitle: 'TECHYID',
    heroSubtitle: 'BEHIND YOUR SUCCESS',
    heroDescription: 'Your trusted partner for electrical equipment, building materials and industrial solutions in Mauritania',
    ctaButton: 'Discover Our Services',
    scrollText: 'Scroll down',
    
    // About Section
    aboutTitle: 'About',
    aboutSubtitle: 'Discover TECHYID, your trusted partner',
    semiFiliale: 'Semi-subsidiary of the AON',
    techyid: 'TECHYID',
    
    // Discover Products Section
    discoverProductsTitle: 'Discover our products',
    viewAllProducts: 'View all products',
    
    // About Section Features
    aboutFeatures: {
      whoWeAre: [
        'Recognized technical expertise',
        'Superior quality products',
        'Exceptional customer service',
        'Complete technical support'
      ],
      history: [
        'Company foundation',
        'Development and growth',
        'Strategic partnerships',
        'Continuous innovation'
      ],
      positioning: [
        'Local and regional market leader',
        'Continental expansion',
        'Future vision',
        'Operational excellence'
      ],
      mission: [
        'Sustainability: environmentally friendly solutions.',
        'Innovation: cutting-edge technologies for tomorrow.',
        'Training: strengthen skills and know-how.',
        'Social impact: concretely improve community life.'
      ]
    },
    aboutDescription1: 'TECHYID is a professional representation and distribution company in Mauritania, specializing in electrical equipment, building materials, industrial materials and infrastructure.',
    aboutDescription2: 'Thanks to its solid relationships with suppliers and its position between Mauritania and Europe, TECHYID offers optimal service, accurate information and competitive prices. TECHYID is the partner of choice for installers, industrials, major accounts and manufacturers.',
    aboutImageAlt: 'About TECHYID',
    
    // About Section Tabs
    aboutTabs: {
      whoWeAre: 'Who We Are',
      history: 'History',
      positioning: 'Positioning',
      values: 'Our Values',
      productLegend: 'Product Families Legend',
      keyMarkets: 'Three Key Markets',
      advantages: 'Only Advantages...',
      mission: 'Our Mission',
      location: 'Headquarters'
    },
    
    aboutContent: {
      whoWeAre: {
        title: 'Who We Are',
        content1: 'TECHYID, Semi-subsidiary of the AON, is the Mauritanian leader in the distribution of electrical equipment for buildings, industry, infrastructure and hospitals.',
        content2: 'Our mission: to offer our clients reliable, innovative and sustainable solutions that meet the most demanding international standards.',
        content3: 'Thanks to our team of technical and commercial experts, we work hand in hand with the largest European manufacturers to guarantee superior quality products, combining performance, safety and energy efficiency.',
        content4: 'At TECHYID, we do more than distribute electrical equipment: we accompany your projects from start to finish to build the energy future of Mauritania and Africa.'
      },
      history: {
        title: 'History',
        content1: 'Since its creation, TECHYID has established itself as a reference player in the electrical sector in Mauritania and the region. Driven by a clear vision and a desire for innovation, the company has evolved with the rhythm of market needs and technological advances.',
        content2: 'Our journey is marked by ambitious projects, strategic partnerships and a constant commitment to quality and excellence. Thanks to our expertise and our ability to adapt, we support our clients in the realization of reliable, modern and sustainable electrical solutions.'
      },
      positioning: {
        title: 'Strategic Positioning',
        content1: 'We position ourselves as the leader in the electrical equipment distribution market in Mauritania, with a stated ambition to extend our influence across the African continent. Through a complete and innovative offer, we provide reliable and sustainable solutions to meet Africa\'s energy challenges and support its growth.'
      },
      values: {
        title: 'Our Values',
        content1: 'With us, every decision, every action, is guided by strong values. They embody our quest for excellence, our integrity and our commitment to offering an exceptional customer experience. With these principles at the heart of everything we do, we build lasting relationships and make a difference, day after day.'
      },
      productLegend: {
        title: 'Product Families',
        intro: 'offers its clients a complete range of products and services, complemented by engineering and technical support, positioning itself as a trusted high-value partner.',
        electricity: {
          title: '1. Electricity',
          subtitle: 'Products and equipment for the electrical sector:',
          items: [
            'Cables, connectors, terminations, and joints',
            'Trunking, conduits, and accessories',
            'Home appliances',
            'Lighting and sources',
            'Industrial equipment',
            'Low-voltage equipment',
            'Safety systems, fire detection, and surge protectors',
            'Instrumentation, measurement, and control',
            'Substation and line equipment',
            'Generators',
            'Battery chargers',
            'IT cabinets and enclosures',
            'Low-current systems'
          ]
        },
        industry: {
          title: '2. Industry',
          subtitle: 'Equipment and solutions for industrial sectors:',
          items: [
            'Mining',
            'Oil & Gas',
            'Power / Electrical',
            'Chemical',
            'Agro-food',
            'Brick factories',
            'Cement plants'
          ]
        },
        building: {
          title: '3. Building',
          subtitle: 'Materials and equipment for construction and building:',
          items: [
            'Waterproofing',
            'Plaster',
            'Tiles',
            'Cladding',
            'Sanitary equipment',
            'Faucets',
            'Sheets, steel, and tubes',
            'Doors'
          ]
        },
        infrastructure: {
          title: '4. Infrastructure',
          subtitle: 'Equipment and solutions for infrastructure projects:',
          items: [
            'Electrification and rural electrification',
            'Airports',
            'Ports',
            'Railways',
            'Hydraulics',
            'Telecom'
          ]
        }
      },
      keyMarkets: {
        title: 'Three Key Markets',
        building: {
          title: 'Building & Tertiary',
          content: 'From affordable housing to high-end buildings, including schools, we accompany our clients at every stage, providing reliability, speed and cost optimization.'
        },
        industry: {
          title: 'Industry',
          content: 'Whether it\'s factories, mining platforms or industrial sites, TECHYID ensures the availability of suitable materials and equipment, relying on solid partnerships with world leaders, to guarantee quality and performance.'
        },
        infrastructure: {
          title: 'Infrastructure',
          content: 'Electricity, telecom, transport, health or sports facilities... We provide robust and sustainable solutions, capable of meeting the highest requirements and realizing your ambitions.'
        },
        conclusion: 'TECHYID, more than a supplier, a partner that transforms your projects into success.'
      },
      advantages: {
        title: 'Only Advantages...',
        subtitle: 'Discover the many advantages that make TECHYID your trusted partner for all your electrical projects',
        items: [
          {
            title: '💰 Economies of Scale',
            content: 'Competitive prices negotiated at national and international level to ensure maximum profit'
          },
          {
            title: '🛡️ Supply Security',
            content: 'Quality and availability guarantee of products thanks to our privileged partnerships'
          },
          {
            title: '🎯 TECHYID Know-How',
            content: 'Recognized technical expertise and in-depth experience in the electrical field'
          },
          {
            title: '🌍 Global Partnerships',
            content: 'Collaboration with the world\'s largest manufacturers for superior quality products'
          },
          {
            title: '⚡ Immediate Availability',
            content: 'Rapid availability of products to meet your project deadlines'
          },
          {
            title: '📋 Market Assistance',
            content: 'Complete support for submission to public and private markets'
          }
        ]
      },
      mission: {
        title: 'Our Mission',
        content1: 'To offer reliable and innovative electrical solutions that support sustainable development and generate positive impact for our partners and communities.',
        valuesTitle: 'Our values:',
        values: [
          {
            title: 'Sustainability',
            content: 'environmentally friendly solutions.'
          },
          {
            title: 'Innovation',
            content: 'cutting-edge technologies for tomorrow.'
          },
          {
            title: 'Training',
            content: 'strengthen skills and know-how.'
          },
          {
            title: 'Social impact',
            content: 'concretely improve the lives of communities.'
          }
        ]
      },
      location: {
        title: 'Headquarters',
        content1: 'TECHYID is located in the heart of Nouakchott, in the Tevragh Zeina district, Cité plage, lot 41.',
        mapButton: '▶ Open in Google Maps'
      }
    },
    
    // Services Section
    servicesTitle: 'Our Services',
    servicesSubtitle: 'A Global Offer',
    service1: 'Monitoring',
    service1Desc: 'Real-time surveillance and control of your electrical installations',
    service2: 'Installation and Commissioning',
    service2Desc: 'Professional installation and commissioning of your electrical equipment',
    service3: 'Cost Management',
    service3Desc: 'Cost analysis and optimization to guarantee the best investment value',
    service4: 'Solar Offer',
    service4Desc: 'Photovoltaic solar solutions for a sustainable energy future',
    service5: 'Project Management',
    service5Desc: 'Complete project management from planning to execution',
    service6: 'Installation & Commissioning',
    service6Desc: 'Professional installation and commissioning services with quality guarantee',
    
    // Products Section
    productsTitle: 'Our Products',
    productsSubtitle: 'Materials and Equipment',
    productCategory1: 'Electrical Distribution Materials & Equipment',
    productCategory2: 'Power Generation Sets',
    productCategory3: 'Electrical Accessories',
    learnMore: 'Learn more',
    sending: 'Sending...',
    
    // All Products Page
    allProducts: 'All Products',
    allProductsSubtitle: 'Discover our complete range of electrical products and solutions',
    backToHome: 'Back to Home',
    searchProducts: 'Search products...',
    allCategories: 'All Categories',
    noProductsFound: 'No products found',
    noProductsFoundText: 'Try adjusting your search or filter criteria',
    viewDetails: 'View Details',
    seeAllProducts: 'See All Products',
    
    // Catalog Page
    catalogTitle: 'Product Catalog',
    viewAllProductsCatalog: 'View all products',
    product: 'Product',
    
    // Cable Categories
    cableTransportTitle: 'Energy transmission and distribution cables',
    cableBuildingsTitle: 'Building cables',
    transformersTitle: 'Transformers',
    switchgearTitle: 'Medium Voltage Switchgear (MV)',
    
    // Other Categories
    prefabricatedSubstationsTitle: 'Prefabricated substations',
    generatorsTitle: 'Generators',
    electricalEquipmentTitle: 'Electrical equipment',
    publicLightingTitle: 'Public lighting',
    
    // Cable Subcategories
    mediumVoltageCablesTitle: 'Medium voltage cables',
    overheadLinesTitle: 'Overhead lines with bare conductors',
    aaacConductorsTitle: 'All-Aluminium Alloy Conductors (AAAC)',
    lowVoltageCablesTitle: 'Low voltage cables',
    
    // Building Cable Subcategories
    standardCables1kvTitle: 'Standard wires and cables 1kV',
    standardCablesLt1kvTitle: 'Standard wires and cables <1kV',
    specialCablesTitle: 'Special cables',
    armouredCablesTitle: 'Armoured cables',
    
    // Switchgear
    fluocellSwitchgearTitle: 'Fluocell switchgear',
    
    // Lighting Categories
    functionalLightingTitle: 'Functional lighting range',
    decorativeLightingTitle: 'Decorative lighting range',
    signageSupportsTitle: 'Signage supports',
    sportsLightingTitle: 'Sports and large-area lighting range',
    
    // Common UI Text
    loadingProducts: 'Loading products...',
    loadingSubcategories: 'Loading subcategories...',
    loadingEnsembles: 'Loading ensembles...',
    loadingSubcategoriesLighting: 'Loading public lighting subcategories...',
    loadingProduct: 'Loading product...',
    loading: 'Loading...',
    subcategoryNotFound: 'Subcategory not found',
    subcategory: 'Subcategory',
    productsAvailable: 'Available products:',
    productsPlural: 'products',
    productSingular: 'product',
    families: 'families',
    
    // Empty States
    noRangesAvailable: 'No ranges available',
    rangesComingSoon: 'Public lighting ranges will be available soon. Contact us for more information.',
    ourLightingRanges: 'Our Lighting Ranges',
    discoverEnsembles: 'Discover ensembles',
    
    // Installation Service Page
    installationServiceTitle: 'Installation & Commissioning',
    installationServiceSubtitle: 'Complete Installation and Commissioning Solution',
    installationServiceIntro: 'through its partnership in Mauritania, is committed to providing systems and services that meet the needs and sustainable development objectives of its partners.',
    installationServiceKeyActor: 'As a key player in electrical equipment distribution, TECHYID stands out through:',
    installationServiceExpertise: 'expertise in reliable and fast procurement,',
    installationServiceInterfaces: 'adapted technical interfaces,',
    installationServiceTesting: 'quality testing and commissioning,',
    installationServiceIntegration: 'complete integration and end-to-end verified solutions,',
    installationServiceQuality: 'guaranteeing a high level of quality and reliability.',
    installationServiceComprehensive: 'understands everything its clients need for their project implementation: software, hardware, and support services, with an approach focused on efficiency and long-term success.',
    installationServiceRange: 'TECHYID offers a complete range of installation and commissioning services to meet all your needs:',
    constructionInstallation: 'Construction & Installation',
    constructionInstallationDesc: 'A leading player in the energy and telecommunications sectors, a reference company for exceptional construction and installation services.',
    commissioning: 'Commissioning',
    commissioningDesc: 'Management & Consultancy to ensure optimal commissioning of your installations.',
    electricalTesting: 'Electrical Testing & Commissioning',
    electricalTestingDesc: 'We will find the reliable and suitable solution for your electrical power needs.',
    instrumentation: 'Instrumentation',
    instrumentationDesc: 'We offer instrument testing and commissioning services to guarantee the precision and reliability of your equipment.',
    telecomIntegration: 'Telecom & System Integration',
    telecomIntegrationDesc: 'ELV & Telecom systems integration for optimal connectivity and communication.',
    
    // Solaire Page
    solairePageTitle: 'Solar Offer',
    solairePageSubtitle: 'Photovoltaic solar energy solutions for a sustainable future.',
    solairePageBreadcrumbServices: 'Services',
    solairePageBreadcrumbSolaire: 'Solar Offer',
    solairePageContentTitle: 'Photovoltaic solar energy',
    solairePageContent1: 'Photovoltaic solar energy is experiencing rapid growth, as is wind energy, on a global scale. However, to achieve "Net-Zero" emissions by 2050, it is imperative to accelerate the pace.',
    solairePageContent2: 'This involves not only multiplying large ground-based solar parks, but also installing solar panels on the roofs of parking lots, commercial and industrial buildings, as well as individual homes.',
    solairePageContent3: 'It is necessary to increase our current photovoltaic solar energy performance by seven times over the next ten years, and this, to meet a rapidly growing demand.',
    solairePageContent4: 'stands as the partner of choice to support and accelerate the realization of these projects through its value proposition.',
    solairePageDocumentationTitle: 'Technical Documentation',
    solairePageCatalogueTitle: 'Solar Offer Catalog',
    
    // Monitoring Page
    monitoringPageTitle: 'MV and LV Monitoring',
    monitoringPageSubtitle: 'Solutions for monitoring MV / LV distribution substations.',
    monitoringPageContent1: 'provides equipment for monitoring MV/LV distribution substations, whether underground or overhead. These multifunctional, modular and communicating solutions play a key role in the operation of Smart Grids (intelligent networks). They allow, for example, to monitor several LV outputs to achieve better load balancing.',
    monitoringPageContent2: 'The transformer temperature can also be monitored, with an SMS alarm sent in case of exceeding a configurable threshold. These solutions can also be used to make other devices communicating, typically an autonomous Fault Detector can be connected to these equipment, which will allow sending the information remotely.',
    monitoringPageProviderText: 'Solutions provided in partnership with',
    monitoringPageCahorsAlt: 'CAHORS',
    
    // Product Details
    productDetails: {
      parafoudre: {
        title: 'Surge Arresters 15 kV - 36 kV',
        description: 'Protection against voltage surges for your electrical installations',
        features: ['Lightning protection', 'Easy installation', 'High durability']
      },
      'cable-bt': {
        title: 'Low Voltage Cable',
        description: 'Electrical cables for low voltage installations',
        features: ['Quality insulation', 'Flexibility', 'Weather resistance']
      },
      'cable-mt': {
        title: 'Medium Voltage Cable',
        description: 'Cables for medium voltage installations',
        features: ['High resistance', 'Reinforced insulation', 'International certification']
      },
      'cable-ht': {
        title: 'High Voltage Cable',
        description: 'Cables for high voltage installations',
        features: ['High performance', 'Maximum safety', 'Standards compliance']
      },
      transformateur: {
        title: 'Transformer',
        description: 'Electrical transformers for power distribution',
        features: ['Energy efficiency', 'Easy maintenance', 'Long lifespan']
      },
      'poste-electrique': {
        title: 'Electrical Substation',
        description: 'Complete electrical transformation substations',
        features: ['Turnkey installation', 'Optimal safety', 'Regulatory compliance']
      },
      'groupe-electrogene': {
        title: 'Generator Set',
        description: 'Generator sets for backup power supply',
        features: ['Automatic start', 'Optimized consumption', 'Simplified maintenance']
      },
      'cellule-arrive-depart': {
        title: 'Incoming/Outgoing Cell',
        description: 'Electrical distribution cells',
        features: ['Compact and robust', 'Easy installation', 'Enhanced safety']
      },
      'ensemble-ancrage-70-40': {
        title: 'Anchoring Set 70/40',
        description: 'Anchoring sets for electrical lines',
        features: ['High resistance', 'Quick installation', 'Guaranteed durability']
      },
      'ensemble-suspension': {
        title: 'Suspension Assembly',
        description: 'Suspension assemblies for electrical lines',
        features: ['Optimal stability', 'Weather resistance', 'Easy installation']
      },
      'ensemble-suspension-2': {
        title: 'Suspension Assembly',
        description: 'Suspension assemblies for electrical lines',
        features: ['Optimal stability', 'Weather resistance', 'Easy installation']
      },
      'ensemble-suspension-3': {
        title: 'Suspension Assembly',
        description: 'Suspension assemblies for electrical lines',
        features: ['Optimal stability', 'Weather resistance', 'Easy installation']
      },
      'iacm-50': {
        title: 'IACM 50',
        description: 'Automatic Manual Cut-off Switch 50A',
        features: ['Automatic protection', 'Manual cut-off', 'High reliability']
      },
      'iacm-100': {
        title: 'IACM 100',
        description: 'Automatic Manual Cut-off Switch 100A',
        features: ['Enhanced protection', 'Manual cut-off', 'High performance']
      }
    },
    
    // Product Detail Page
    backToProducts: '← Back to products',
    suppliedBy: 'Supplied by',
    mainFeatures: '✓ Main features',
    technicalSpecs: '⚙️ Technical specifications',
    productNotFound: 'Product not found',
    productNotFoundDesc: 'The requested product does not exist.',
    interestedInProduct: 'Interested in this product?',
    contactForQuote: 'Contact us to get a personalized quote and technical advice',
    requestQuote: 'Request a quote',
    
    // Specification Labels
    nominalVoltage: 'Nominal Voltage',
    dischargeCurrent: 'Discharge Current',
    responseTime: 'Response Time',
    temperature: 'Temperature',
    certification: 'Certification',
    power: 'Power',
    primaryVoltage: 'Primary Voltage',
    secondaryVoltage: 'Secondary Voltage',
    efficiency: 'Efficiency',
    fuel: 'Fuel',
    voltage: 'Voltage',
    current: 'Current',
    type: 'Type',
    protection: 'Protection',
    charge: 'Charge',
    material: 'Material',
    diameter: 'Diameter',
    length: 'Length',
    
    // Markets Section
    marketsTitle: 'Our Markets',
    marketsSubtitle: 'Activity Sectors',
    market1: 'Building & Tertiary',
    market1Desc: 'Electrical solutions for building and tertiary sector',
    market2: 'Industry',
    market2Desc: 'Industrial equipment and specialized technical solutions',
    market3: 'Infrastructure',
    market3Desc: 'Materials and equipment for infrastructure projects',
    
    // Market Features
    marketFeatures: {
      building: ['Housing', 'Schools', 'Offices', 'Commerce'],
      industry: ['Mining', 'Oil', 'Food Industry', 'Maintenance'],
      infrastructure: ['Electrification', 'Telecom', 'Transport', 'Energy']
    },
    
    // Partners Section
    partnersTitle: 'Our Partners',
    partnersSubtitle: 'Trusted partners for excellence solutions',
    partnersDescription: 'TECHYID collaborates with the world\'s largest manufacturers to offer you superior quality products and innovative solutions.',
    trustTitle: 'Trusted Partners',
    trustDescription: 'Thanks to our privileged partnerships with industry leaders, we guarantee you superior quality products, competitive prices and first-class technical support.',
    trustedClientsTitle: 'They trusted us',
    
    // Partner Details
    partnerDetails: {
      nexans: {
        name: 'Nexans',
        description: 'Cables and connectivity solutions'
      },
      deutz: {
        name: 'DEUTZ',
        description: 'High quality engines and generators'
      },
      ines: {
        name: 'Ines Max',
        description: 'Electrical and safety solutions'
      },
      cahors: {
        name: 'CAHORS',
        description: 'Electrical and distribution equipment'
      },
      ifamel: {
        name: 'IFAMEL',
        description: 'Electrical equipment and industrial solutions'
      },
      marcont: {
        name: 'Marcont',
        description: 'Electrical and industrial equipment solutions'
      }
    },
    
    // Advantages Section
    advantagesTitle: 'Our Advantages',
    advantagesSubtitle: 'Discover the advantages that distinguish us',
    advantage1: 'TECHYID particular know-how',
    advantage2: 'Security in terms of supply quality',
    advantage3: 'Product availability',
    advantage4: 'Partnerships with major global manufacturers',
    advantage5: 'Economies of scale through competitive prices',
    advantage6: 'Experience exchanges',
    advantage7: 'Free technical assistance',
    advantage8: 'Assistance for tender submissions',
    
    // Advantages Array (for Markets component)
    advantages: [
      'Economies of scale through competitive prices',
      'Security in terms of supply quality',
      'TECHYID particular know-how',
      'Partnerships with major global manufacturers',
      'Product availability',
      'Free technical assistance',
      'Assistance for tender submissions',
      'Experience exchanges'
    ],
    
    // Contact Section
    contactTitle: 'Contact Us',
    contactSubtitle: 'We are here to listen',
    address: 'Tevragh Zeina, Cité plage, lot 41 Nouakchott, Mauritania',
    phone: '+222 48 61 06 89',
    email: 'contact@techyid.com',
    contactForm: {
      name: 'Name',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      send: 'Send',
    },
    locationTitle: 'Our Location',
    locationDescription: 'Located in the heart of Nouakchott, we are easily accessible and at your disposal for all your electrical equipment and industrial solutions needs.',
    messageSent: 'Message sent successfully!',
    
    // Footer
    footerText: '© 2026 TECHYID. All rights reserved.',
    developerCredit: 'Developed by Overcode.dev',
    slogan: 'Leader in electrical equipment distribution in Mauritania',
    footerContact: 'Contact',
    followUs: 'Follow us',
    workingHours: 'Sun - Thu: 8:00 AM - 5:00 PM',

    // Admin Dashboard
    admin: {
      title: "Administration",
      overview: "Overview",
      dashboard: "Dashboard",
      totalProducts: "Total Products",
      activeMarkets: "Active Markets",
      partners: "Partners",
      globalReach: "Global Reach",
      dashboardOverview: "Dashboard Overview"
    },

    // Login Page
    login: {
      title: "Admin Login",
      subtitle: "Enter your credentials to access the dashboard",
      emailLabel: "Email Address",
      passwordLabel: "Password",
      emailPlaceholder: "Enter your email address",
      passwordPlaceholder: "Enter your password",
      loginButton: "Sign In",
      loggingIn: "Logging In...",
      invalidCredentials: "Invalid credentials",
      loginError: "Login error. Please try again."
    },

    // Language Names
    languages: {
      en: "English",
      fr: "Français",
      ar: "العربية"
    },

    // Alt Texts and Labels
    altTexts: {
      logo: "TECHYID",
      location: "Location",
      phone: "Phone",
      email: "Email",
      time: "Hours",
      facebook: "Facebook",
      scrollToTop: "Scroll to top"
    },

    // Accessibility Labels
    accessibility: {
      toggleMobileMenu: "Toggle mobile menu",
      hidePassword: "Hide password",
      showPassword: "Show password",
      noDate: "No date"
    },

    // Statistics
    statistics: {
      yearsExperience: "Years Experience",
      projectsCompleted: "Projects Completed",
      trustedPartners: "Trusted Partners",
      clientSatisfaction: "Client Satisfaction"
    },
    showMore: "Show more",
  },
  
  ar: {
    // Navigation
    home: 'الرئيسية',
    about: 'من نحن',
    services: 'الخدمات',
    products: 'المنتجات',
    markets: 'الأسواق',
    partners: 'الشركاء',
    contact: 'اتصل بنا',
    
    // Hero Section
    heroTitle: 'تشييد',
    heroSubtitle: 'خلف نجاحك',
    heroDescription: 'شريكك الموثوق للمعدات الكهربائية ومواد البناء والحلول الصناعية في موريتانيا',
    ctaButton: 'اكتشف خدماتنا',
    scrollText: 'مرر للأسفل',
    
    // About Section
    aboutTitle: 'معلومات عن التشييد',
    aboutSubtitle: 'اكتشف تشييد، شريكك الموثوق',
    semiFiliale: 'شبه فرع لمجموعة AON',
    techyid: 'التشييد',
    
    // Discover Products Section
    discoverProductsTitle: 'اكتشف منتجاتنا',
    viewAllProducts: 'عرض جميع المنتجات',
    
    // About Section Features
    aboutFeatures: {
      whoWeAre: [
        'خبرة تقنية معترف بها',
        'منتجات عالية الجودة',
        'خدمة عملاء استثنائية',
        'دعم تقني شامل'
      ],
      history: [
        'تأسيس الشركة',
        'التطوير والنمو',
        'شراكات استراتيجية',
        'ابتكار مستمر'
      ],
      positioning: [
        'رائد السوق المحلي والإقليمي',
        'التوسع القاري',
        'رؤية مستقبلية',
        'التميز التشغيلي'
      ],
      mission: [
        'الاستدامة: حلول صديقة للبيئة.',
        'الابتكار: تقنيات متطورة للغد.',
        'التدريب: تعزيز المهارات والمعرفة.',
        'التأثير الاجتماعي: تحسين حياة المجتمعات بشكل ملموس.'
      ]
    },
    aboutDescription1: 'تشييد هي شركة متخصصة في التمثيل والتوزيع في موريتانيا، متخصصة في المعدات الكهربائية ومواد البناء والمواد الصناعية والبنية التحتية.',
    aboutDescription2: 'بفضل علاقاتها القوية مع الموردين وموقعها بين موريتانيا وأوروبا، تقدم تشييد خدمة مثلى ومعلومات دقيقة وأسعار تنافسية. تشييد هي الشريك المفضل للمثبتين والصناعيين والحسابات الكبيرة والمصنعين.',
    aboutImageAlt: 'حول تشييد',
    
    // About Section Tabs
    aboutTabs: {
      whoWeAre: 'من نحن',
      history: 'التاريخ',
      positioning: 'الموقع',
      values: 'قيمنا',
      productLegend: 'تصنيف عائلات المنتجات',
      keyMarkets: 'الأسواق الرئيسية الثلاثة',
      advantages: 'مزايا فقط...',
      mission: 'مهمتنا',
      location: 'المقر الرئيسي'
    },
    
    aboutContent: {
      whoWeAre: {
        title: 'من نحن',
        content1: 'هي الرائدة في موريتانيا في مجال توزيع المعدات الكهربائية الخاصة بالبناء، والصناعة، والبنية التحتية، والمستشفيات.',
        content2: 'مهمتنا: تقديم حلول موثوقة، مبتكرة ومستدامة لعملائنا، تلبي أعلى المعايير الدولية.',
        content3: 'بفضل فريقنا من الخبراء الفنيين والتجاريين، نعمل جنبًا إلى جنب مع أكبر المصنّعين الأوروبيين لضمان منتجات عالية الجودة تجمع بين الأداء، والسلامة، وكفاءة الطاقة.',
        content4: 'في التشييد، لا نكتفي بتوزيع المعدات الكهربائية فحسب، بل نرافق مشاريعكم من البداية إلى النهاية لبناء مستقبل الطاقة في موريتانيا وإفريقيا.'
      },
      history: {
        title: 'التاريخ',
        content1: 'منذ تأسيسها، فرضت التشييد نفسها كفاعل مرجعي في القطاع الكهربائي في موريتانيا وفي المنطقة. وبفضل رؤيتها الواضحة وإرادتها الراسخة في الابتكار، استطاعت الشركة مواكبة احتياجات السوق والتطورات التكنولوجية.',
        content2: 'مسيرتنا حافلة بالمشاريع الطموحة، والشراكات الاستراتيجية، والالتزام الدائم بالجودة والتميز. وبفضل خبرتنا وقدرتنا على التكيّف، نرافق عملاءنا في إنجاز حلول كهربائية موثوقة، عصرية ومستدامة.'
      },
      positioning: {
        title: 'الموقع الاستراتيجي',
        content1: 'نحن نضع أنفسنا كقادة في سوق توزيع المعدات الكهربائية في موريتانيا، بطموح مؤكد لتوسيع نفوذنا على نطاق القارة الأفريقية. بفضل عرض شامل ومبتكر، نقدم حلولاً موثوقة ومستدامة لمواجهة التحديات الطاقية لأفريقيا ومرافقة نموها.'
      },
      values: {
        title: 'قيمنا',
        content1: 'معنا، كل قرار، كل عمل، يوجهه قيم قوية. تجسد سعينا للتميز ونزاهتنا والتزامنا بتقديم تجربة عملاء استثنائية. بهذه المبادئ في قلب كل ما نقوم به، نبني علاقات دائمة ونصنع الفرق، يوماً بعد يوم.'
      },
      productLegend: {
        title: 'تصنيف عائلات المنتجات',
        intro: 'تقدّم التشييد لعملائها مجموعة متكاملة من المنتجات والخدمات، مدعومة بخدمات هندسية وتقنية، لتفرض نفسها كشريك مفضل ذو قيمة مضافة عالية.',
        electricity: {
          title: '1. الكهرباء',
          subtitle: 'منتجات ومعدات للقطاع الكهربائي:',
          items: [
            'الكابلات، الوصلات، النهايات والوصلات البينية',
            'المجاري، القنوات والملحقات',
            'الأجهزة المنزلية',
            'الإضاءة ومصادرها',
            'المعدات الصناعية',
            'معدات الجهد المنخفض',
            'أنظمة السلامة، كشف الحرائق وموانع الصواعق',
            'أجهزة القياس، التحكم والتنظيم',
            'معدات المحطات وخطوط النقل',
            'المولدات الكهربائية',
            'شواحن البطاريات',
            'الخزائن والأرفف المعلوماتية',
            'أنظمة التيار الضعيف'
          ]
        },
        industry: {
          title: '2. الصناعة',
          subtitle: 'معدات وتجهيزات للقطاعات الصناعية:',
          items: [
            'التعدين',
            'النفط والغاز',
            'الكهرباء',
            'الصناعات الكيميائية',
            'الصناعات الغذائية',
            'مصانع الطوب',
            'مصانع الإسمنت'
          ]
        },
        building: {
          title: '3. البناء',
          subtitle: 'معدات وتجهيزات للبناء والإنشاءات:',
          items: [
            'العزل',
            'الجبس',
            'البلاط',
            'الواجهات المعدنية (البرداج)',
            'الأدوات الصحية',
            'الصنابير',
            'الصفائح، الفولاذ والأنابيب',
            'الأبواب'
          ]
        },
        infrastructure: {
          title: '4. البنية التحتية',
          subtitle: 'معدات وتجهيزات للبنى التحتية:',
          items: [
            'الكهرباء والكهرباء الريفية',
            'المطارات',
            'الموانئ',
            'السكك الحديدية',
            'الهيدروليك',
            'الاتصالات'
          ]
        }
      },
      keyMarkets: {
        title: 'الأسواق الرئيسية الثلاثة',
        building: {
          title: 'البناء والخدمات',
          content: 'من السكن الاقتصادي إلى المباني الراقية، مروراً بالمدارس، نرافق عملاءنا في كل مرحلة، مع إحضار الموثوقية والسرعة وتحسين التكاليف.'
        },
        industry: {
          title: 'الصناعة',
          content: 'سواء كانت مصانع أو منصات تعدين أو مواقع صناعية، تضمن تشييد توفر المواد والمعدات المناسبة، مع الاعتماد على شراكات قوية مع القادة العالميين، لضمان الجودة والأداء.'
        },
        infrastructure: {
          title: 'البنية التحتية',
          content: 'الكهرباء، الاتصالات، النقل، الصحة أو المرافق الرياضية... نقدم حلولاً قوية ومستدامة، قادرة على تلبية أعلى المتطلبات وتحقيق طموحاتكم.'
        },
        conclusion: 'تشييد، أكثر من مورد، شريك يحول مشاريعكم إلى نجاح.'
      },
      advantages: {
        title: 'مزايا فقط...',
        subtitle: 'اكتشفوا المزايا العديدة التي تجعل تشييد شريككم الموثوق لجميع مشاريعكم الكهربائية',
        items: [
          {
            title: '💰 اقتصاديات الحجم',
            content: 'أسعار تنافسية مفاوض عليها على المستوى الوطني والدولي لضمان أقصى ربح'
          },
          {
            title: '🛡️ أمان التوريد',
            content: 'ضمان الجودة والتوفر للمنتجات بفضل شراكاتنا المميزة'
          },
          {
            title: '🎯 خبرة تشييد',
            content: 'خبرة تقنية معترف بها وتجربة عميقة في المجال الكهربائي'
          },
          {
            title: '🌍 الشراكات العالمية',
            content: 'التعاون مع أكبر الشركات المصنعة العالمية لمنتجات عالية الجودة'
          },
          {
            title: '⚡ التوفر الفوري',
            content: 'توفر سريع للمنتجات لاحترام مواعيد مشاريعكم'
          },
          {
            title: '📋 مساعدة الأسواق',
            content: 'دعم كامل للتقديم على الأسواق العامة والخاصة'
          }
        ]
      },
      mission: {
        title: 'مهمتنا',
        content1: 'تقديم حلول كهربائية موثوقة ومبتكرة تدعم التنمية المستدامة وتولد تأثيراً إيجابياً لشركائنا والمجتمعات.',
        valuesTitle: 'قيمنا:',
        values: [
          {
            title: 'الاستدامة',
            content: 'حلول محترمة للبيئة.'
          },
          {
            title: 'الابتكار',
            content: 'تقنيات متطورة للغد.'
          },
          {
            title: 'التدريب',
            content: 'تعزيز المهارات والخبرة.'
          },
          {
            title: 'التأثير الاجتماعي',
            content: 'تحسين ملموس لحياة المجتمعات.'
          }
        ]
      },
      location: {
        title: 'المقر الرئيسي',
        content1: 'تشييد تقع في قلب نواكشوط، في حي تفرغ زينة، سيتي بلاج، قطعة 41.',
        mapButton: '▶ فتح في خرائط جوجل'
      }
    },
    
    // Services Section
    servicesTitle: 'خدماتنا',
    servicesSubtitle: 'عرض شامل',
    service1: 'المراقبة',
    service1Desc: 'مراقبة وتحكم في الوقت الفعلي لتركيباتكم الكهربائية',
    service2: 'التركيب والتشغيل',
    service2Desc: 'تركيب وتشغيل احترافي لمعداتكم الكهربائية',
    service3: 'إدارة التكاليف',
    service3Desc: 'تحليل وتحسين التكاليف لضمان أفضل قيمة استثمارية',
    service4: 'العرض الشمسي',
    service4Desc: 'حلول شمسية ضوئية لمستقبل طاقوي مستدام',
    service5: 'إدارة المشاريع',
    service5Desc: 'إدارة كاملة للمشاريع من التخطيط إلى التنفيذ',
    service6: 'التركيب والتشغيل',
    service6Desc: 'خدمات التركيب والتشغيل المهنية مع ضمان الجودة',
    
    // Products Section
    productsTitle: 'منتجاتنا',
    productsSubtitle: 'المواد والمعدات',
    productCategory1: 'مواد ومعدات التوزيع الكهربائي',
    productCategory2: 'مجموعات الطاقة',
    productCategory3: 'الملحقات الكهربائية',
    learnMore: 'اعرف المزيد',
    sending: 'جاري الإرسال...',
    
    // All Products Page
    allProducts: 'جميع المنتجات',
    allProductsSubtitle: 'اكتشف مجموعتنا الكاملة من المنتجات والحلول الكهربائية',
    backToHome: 'العودة إلى الرئيسية',
    searchProducts: 'البحث في المنتجات...',
    allCategories: 'جميع الفئات',
    noProductsFound: 'لم يتم العثور على منتجات',
    noProductsFoundText: 'حاول تعديل معايير البحث أو التصفية',
    viewDetails: 'عرض التفاصيل',
    seeAllProducts: 'عرض جميع المنتجات',
    
    // Catalog Page
    catalogTitle: 'كتالوج المنتجات',
    viewAllProductsCatalog: 'عرض جميع المنتجات',
    product: 'منتج',
    
    // Cable Categories
    cableTransportTitle: 'كابلات نقل وتوزيع الطاقة',
    cableBuildingsTitle: 'كابلات المباني',
    transformersTitle: 'المحوّلات الكهربائية',
    switchgearTitle: 'خلايا الجهد المتوسط',
    
    // Other Categories
    prefabricatedSubstationsTitle: 'محطات جاهزة مسبقة الصنع',
    generatorsTitle: 'المولدات الكهربائية',
    electricalEquipmentTitle: 'المعدات الكهربائية',
    publicLightingTitle: 'الإنارة العمومية',
    
    // Cable Subcategories
    mediumVoltageCablesTitle: 'كابلات الجهد المتوسط',
    overheadLinesTitle: 'أسلاك هوائية ذات موصلات عارية',
    aaacConductorsTitle: 'موصلات من سبيكة الألمنيوم (AAAC)',
    lowVoltageCablesTitle: 'كابلات الجهد المنخفض',
    
    // Building Cable Subcategories
    standardCables1kvTitle: 'أسلاك وكابلات قياسية 1 ك.ف',
    standardCablesLt1kvTitle: 'أسلاك وكابلات قياسية أقل من 1 ك.ف',
    specialCablesTitle: 'كابلات خاصة',
    armouredCablesTitle: 'كابلات مُدرّعة',
    
    // Switchgear
    fluocellSwitchgearTitle: 'خلايا Fluocell',
    
    // Lighting Categories
    functionalLightingTitle: 'مجموعة الإنارة الوظيفية',
    decorativeLightingTitle: 'مجموعة الإنارة الزخرفية',
    signageSupportsTitle: 'دعامات الإشارات',
    sportsLightingTitle: 'مجموعة إنارة الملاعب والمساحات الواسعة',
    
    // Common UI Text
    loadingProducts: 'جاري تحميل المنتجات...',
    loadingSubcategories: 'جاري تحميل الفئات الفرعية...',
    loadingEnsembles: 'جاري تحميل المجموعات...',
    loadingSubcategoriesLighting: 'جاري تحميل فئات الإنارة العمومية الفرعية...',
    loadingProduct: 'جاري تحميل المنتج...',
    loading: 'جاري التحميل...',
    subcategoryNotFound: 'الفئة الفرعية غير موجودة',
    subcategory: 'فئة فرعية',
    productsAvailable: 'المنتجات المتاحة:',
    productsPlural: 'منتجات',
    productSingular: 'منتج',
    families: 'عائلات',
    
    // Empty States
    noRangesAvailable: 'لا توجد مجموعات متاحة',
    rangesComingSoon: 'ستكون مجموعات الإنارة العمومية متاحة قريباً. اتصلوا بنا للحصول على مزيد من المعلومات.',
    ourLightingRanges: 'مجموعات الإنارة الخاصة بنا',
    discoverEnsembles: 'اكتشفوا المجموعات',
    
    // Installation Service Page
    installationServiceTitle: 'التركيب والتشغيل',
    installationServiceSubtitle: 'حل شامل للتركيب والتشغيل',
    installationServiceIntro: 'من خلال شراكتها في موريتانيا، تلتزم بتقديم أنظمة وخدمات تلبي احتياجات وأهداف التنمية المستدامة لشركائها.',
    installationServiceKeyActor: 'كفاعل رئيسي في توزيع المعدات الكهربائية، تتميز التشييد بما يلي:',
    installationServiceExpertise: 'خبرة في التوريد الموثوق والسريع،',
    installationServiceInterfaces: 'واجهات تقنية متكيفة،',
    installationServiceTesting: 'اختبارات وتشغيل عالي الجودة،',
    installationServiceIntegration: 'تكامل شامل وحلول محققة من البداية للنهاية،',
    installationServiceQuality: 'ضمان مستوى عالٍ من الجودة والموثوقية.',
    installationServiceComprehensive: 'تفهم كل ما يحتاجه عملاؤها لتنفيذ مشاريعهم: البرمجيات، الأجهزة، وخدمات الدعم، مع نهج يركز على الكفاءة والنجاح على المدى الطويل.',
    installationServiceRange: 'تقدم التشييد مجموعة شاملة من خدمات التركيب والتشغيل لتلبية جميع احتياجاتكم:',
    constructionInstallation: 'البناء والتركيب',
    constructionInstallationDesc: 'فاعل رائد في قطاعات الطاقة والاتصالات، شركة مرجعية لخدمات البناء والتركيب الاستثنائية.',
    commissioning: 'التشغيل',
    commissioningDesc: 'الإدارة والاستشارة لضمان تشغيل مثالي لتركيباتكم.',
    electricalTesting: 'الاختبارات الكهربائية والتشغيل',
    electricalTestingDesc: 'سنجد الحل الموثوق والمناسب لاحتياجاتكم من الطاقة الكهربائية.',
    instrumentation: 'الأجهزة والقياس',
    instrumentationDesc: 'نقدم خدمات اختبار وتشغيل الأجهزة لضمان دقة وموثوقية معداتكم.',
    telecomIntegration: 'تكامل الاتصالات والأنظمة',
    telecomIntegrationDesc: 'تكامل أنظمة الجهد المنخفض والاتصالات للاتصال والتواصل الأمثل.',
    
    // Solaire Page
    solairePageTitle: 'العرض الشمسي',
    solairePageSubtitle: 'حلول الطاقة الشمسية الضوئية لمستقبل مستدام.',
    solairePageBreadcrumbServices: 'الخدمات',
    solairePageBreadcrumbSolaire: 'العرض الشمسي',
    solairePageContentTitle: 'الطاقة الشمسية الضوئية',
    solairePageContent1: 'تشهد الطاقة الشمسية الضوئية نمواً سريعاً، تماماً مثل طاقة الرياح، على نطاق عالمي. ومع ذلك، لتحقيق انبعاثات "صفر صافي" بحلول عام 2050، من الضروري تسريع الوتيرة.',
    solairePageContent2: 'هذا يتضمن ليس فقط مضاعفة المزارع الشمسية الكبيرة على الأرض، بل أيضاً تركيب الألواح الشمسية على أسطح مواقف السيارات والمباني التجارية والصناعية، وكذلك المنازل الفردية.',
    solairePageContent3: 'من الضروري زيادة أدائنا الحالي في الطاقة الشمسية الضوئية سبع مرات خلال السنوات العشر القادمة، وذلك للاستجابة لطلب متزايد بسرعة.',
    solairePageContent4: 'تعتبر الشريك المفضل لدعم وتسريع تحقيق هذه المشاريع من خلال مقترح القيمة الخاص بها.',
    solairePageDocumentationTitle: 'الوثائق التقنية',
    solairePageCatalogueTitle: 'كتالوج العرض الشمسي',
    
    // Monitoring Page
    monitoringPageTitle: 'مراقبة الجهد المتوسط والمنخفض',
    monitoringPageSubtitle: 'حلول لمراقبة محطات توزيع الجهد المتوسط / المنخفض.',
    monitoringPageContent1: 'توفر معدات لمراقبة محطات توزيع الجهد المتوسط/المنخفض، سواء كانت تحت الأرض أو هوائية. هذه الحلول متعددة الوظائف وقابلة للتعديل ومتواصلة تلعب دوراً رئيسياً في تشغيل الشبكات الذكية. تسمح، على سبيل المثال، بمراقبة عدة مخرجات الجهد المنخفض لتحقيق توازن أفضل للأحمال.',
    monitoringPageContent2: 'يمكن أيضاً مراقبة درجة حرارة المحول، مع إرسال إنذار SMS في حالة تجاوز عتبة قابلة للتكوين. يمكن أيضاً استخدام هذه الحلول لجعل أجهزة أخرى متواصلة، عادة يمكن توصيل كاشف الأعطال المستقل بهذه المعدات، مما سيسمح بإرسال المعلومات عن بُعد.',
    monitoringPageProviderText: 'حلول مقدمة بالشراكة مع',
    monitoringPageCahorsAlt: 'كاهورس',
    
    // Product Details
    productDetails: {
      parafoudre: {
        title: 'مانع الصواعق',
        description: 'حماية من ارتفاع الجهد للمنشآت الكهربائية',
        features: ['حماية من الصواعق', 'تركيب سهل', 'متانة عالية']
      },
      'cable-bt': {
        title: 'كابل الجهد المنخفض',
        description: 'كابلات كهربائية للمنشآت ذات الجهد المنخفض',
        features: ['عزل عالي الجودة', 'مرونة', 'مقاومة للعوامل الجوية']
      },
      'cable-mt': {
        title: 'كابل الجهد المتوسط',
        description: 'كابلات للمنشآت ذات الجهد المتوسط',
        features: ['مقاومة عالية', 'عزل معزز', 'شهادة دولية']
      },
      'cable-ht': {
        title: 'كابل الجهد العالي',
        description: 'كابلات للمنشآت ذات الجهد العالي',
        features: ['أداء عالي', 'أمان أقصى', 'امتثال للمعايير']
      },
      transformateur: {
        title: 'محول كهربائي',
        description: 'محولات كهربائية لتوزيع الطاقة',
        features: ['كفاءة طاقوية', 'صيانة سهلة', 'عمر طويل']
      },
      'poste-electrique': {
        title: 'محطة كهربائية',
        description: 'محطات تحويل كهربائية كاملة',
        features: ['تركيب مفتاح في اليد', 'أمان مثالي', 'امتثال تنظيمي']
      },
      'groupe-electrogene': {
        title: 'مجموعة مولدات',
        description: 'مجموعات مولدات لإمداد الطاقة الاحتياطي',
        features: ['بدء تلقائي', 'استهلاك محسن', 'صيانة مبسطة']
      },
      'cellule-arrive-depart': {
        title: 'خلية الوصول والمغادرة',
        description: 'خلايا التوزيع الكهربائي',
        features: ['مضغوطة وقوية', 'تركيب سهل', 'أمان معزز']
      },
      'ensemble-ancrage-70-40': {
        title: 'مجموعة التثبيت 70/40',
        description: 'مجموعات التثبيت المعززة للخطوط الكهربائية',
        features: ['مقاومة عالية', 'تركيب آمن', 'عمر طويل']
      },
      'ensemble-suspension': {
        title: 'مجموعة التعليق',
        description: 'مجموعات التعليق للخطوط الكهربائية',
        features: ['استقرار مثالي', 'مقاومة للعوامل الجوية', 'تركيب سهل']
      },
      'ensemble-suspension-2': {
        title: 'مجموعة التعليق',
        description: 'مجموعات التعليق للخطوط الكهربائية',
        features: ['استقرار مثالي', 'مقاومة للعوامل الجوية', 'تركيب سهل']
      },
      'ensemble-suspension-3': {
        title: 'مجموعة التعليق',
        description: 'مجموعات التعليق للخطوط الكهربائية',
        features: ['استقرار مثالي', 'مقاومة للعوامل الجوية', 'تركيب سهل']
      },
      'iacm-50': {
        title: 'مفتاح القطع التلقائي اليدوي 50A',
        description: 'مفتاح قطع تلقائي يدوي 50 أمبير',
        features: ['حماية تلقائية', 'قطع يدوي', 'موثوقية عالية']
      },
      'iacm-100': {
        title: 'مفتاح القطع التلقائي اليدوي 100A',
        description: 'مفتاح قطع تلقائي يدوي 100 أمبير',
        features: ['حماية معززة', 'قطع يدوي', 'أداء عالي']
      }
    },
    
    // Product Detail Page
    suppliedBy: 'مقدم من',
    mainFeatures: '✓ الميزات الرئيسية',
    technicalSpecs: '⚙️ المواصفات التقنية',
    productNotFound: 'المنتج غير موجود',
    productNotFoundDesc: 'المنتج المطلوب غير موجود.',
    interestedInProduct: 'مهتم بهذا المنتج؟',
    contactForQuote: 'اتصل بنا للحصول على عرض سعر مخصص ونصائح تقنية',
    requestQuote: 'طلب عرض سعر',
    
    // Specification Labels
    nominalVoltage: 'الجهد الاسمي',
    dischargeCurrent: 'تيار التفريغ',
    responseTime: 'وقت الاستجابة',
    temperature: 'درجة الحرارة',
    certification: 'الشهادة',
    power: 'الطاقة',
    primaryVoltage: 'الجهد الأساسي',
    secondaryVoltage: 'الجهد الثانوي',
    efficiency: 'الكفاءة',
    fuel: 'الوقود',
    voltage: 'الجهد',
    current: 'التيار',
    type: 'النوع',
    protection: 'الحماية',
    charge: 'الشحنة',
    material: 'المادة',
    diameter: 'القطر',
    length: 'الطول',
    
    // Markets Section
    marketsTitle: 'أسواقنا',
    marketsSubtitle: 'قطاعات النشاط',
    market1: 'البناء والخدمات',
    market1Desc: 'الحلول الكهربائية لقطاع البناء والخدمات',
    market2: 'الصناعة',
    market2Desc: 'المعدات الصناعية والحلول التقنية المتخصصة',
    market3: 'البنية التحتية',
    market3Desc: 'المواد والمعدات لمشاريع البنية التحتية',
    
    // Market Features
    marketFeatures: {
      building: ['السكن', 'المدارس', 'المكاتب', 'التجارة'],
      industry: ['التعدين', 'النفط', 'الصناعات الغذائية', 'الصيانة'],
      infrastructure: ['الكهربة', 'الاتصالات', 'النقل', 'الطاقة']
    },
    
    // Partners Section
    partnersTitle: 'شركاؤنا',
    partnersSubtitle: 'شركاء موثوقون لحلول متميزة',
    partnersDescription: 'تتعاون تشييد مع أكبر الشركات المصنعة في العالم لتقدم لك منتجات عالية الجودة وحلول مبتكرة.',
    trustTitle: 'شركاء موثوقون',
    trustDescription: 'بفضل شراكاتنا المميزة مع قادة الصناعة، نضمن لك منتجات عالية الجودة وأسعار تنافسية ودعم تقني من الدرجة الأولى.',
    trustedClientsTitle: 'لقد وثقوا بنا',
    
    // Partner Details
    partnerDetails: {
      nexans: {
        name: 'نيكسان',
        description: 'كابلات وحلول الاتصال'
      },
      deutz: {
        name: 'دوتز',
        description: 'محركات ومولدات عالية الجودة'
      },
      ines: {
        name: 'إنيس ماكس',
        description: 'حلول كهربائية وأمان'
      },
      cahors: {
        name: 'كاهورس',
        description: 'معدات كهربائية وتوزيع'
      },
      ifamel: {
        name: 'IFAMEL',
        description: 'Electrical equipment and industrial solutions'
      },
      marcont: {
        name: 'Marcont',
        description: 'Electrical and industrial equipment solutions'
      }
    },
    
    // Advantages Section
    advantagesTitle: 'مزايانا',
    advantagesSubtitle: 'اكتشفوا المزايا التي تميزنا',
    advantage1: 'الخبرة الخاصة لتشييد',
    advantage2: 'الأمان من ناحية جودة التوريد',
    advantage3: 'توفر المنتجات',
    advantage4: 'شراكات مع كبار المصنعين العالميين',
    advantage5: 'وفورات الحجم من خلال الأسعار التنافسية',
    advantage6: 'تبادل الخبرات',
    advantage7: 'المساعدة التقنية المجانية',
    advantage8: 'المساعدة في تقديم العطاءات',
    
    // Advantages Array (for Markets component)
    advantages: [
      'وفورات الحجم من خلال الأسعار التنافسية',
      'الأمان من ناحية جودة التوريد',
      'الخبرة الخاصة لتشييد',
      'شراكات مع كبار المصنعين العالميين',
      'توفر المنتجات',
      'المساعدة التقنية المجانية',
      'المساعدة في تقديم العطاءات',
      'تبادل الخبرات'
    ],
    
    // Contact Section
    contactTitle: 'اتصل بنا',
    contactSubtitle: 'نحن هنا للاستماع',
    address: 'تفرغ زينة، سيتي بلاج، قطعة 41 نواكشوط، موريتانيا',
    phone: '+222 48 61 06 89',
    email: 'contact@techyid.com',
    contactForm: {
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      subject: 'الموضوع',
      message: 'الرسالة',
      send: 'إرسال',
    },
    locationTitle: 'موقعنا',
    locationDescription: 'نقع في قلب نواكشوط، نحن في متناول اليد ونتوفر لجميع احتياجاتك في المعدات الكهربائية والحلول الصناعية.',
    messageSent: 'تم إرسال الرسالة بنجاح!',
    
    // Footer
    footerText: '© 2026 تشييد. جميع الحقوق محفوظة.',
    developerCredit: 'تم التطوير بواسطة Overcode.dev',
    slogan: 'الرائد في توزيع المعدات الكهربائية في موريتانيا',
    footerContact: 'اتصل بنا',
    followUs: 'تابعنا',
    workingHours: 'الخميس - الأحد: 8:00 - 17:00',

    // Admin Dashboard
    admin: {
      title: "الإدارة",
      overview: "نظرة عامة",
      dashboard: "لوحة القيادة",
      totalProducts: "إجمالي المنتجات",
      activeMarkets: "الأسواق النشطة",
      partners: "الشركاء",
      globalReach: "الوصول العالمي",
      dashboardOverview: "نظرة عامة على لوحة القيادة"
    },

    // Login Page
    login: {
      title: "تسجيل دخول المسؤول",
      subtitle: "أدخل بيانات الاعتماد الخاصة بك للوصول إلى لوحة القيادة",
      emailLabel: "عنوان البريد الإلكتروني",
      passwordLabel: "كلمة المرور",
      emailPlaceholder: "أدخل عنوان بريدك الإلكتروني",
      passwordPlaceholder: "أدخل كلمة المرور الخاصة بك",
      loginButton: "تسجيل الدخول",
      loggingIn: "جاري تسجيل الدخول...",
      invalidCredentials: "بيانات اعتماد غير صالحة",
      loginError: "خطأ في تسجيل الدخول. يرجى المحاولة مرة أخرى."
    },

    // Language Names
    languages: {
      en: "الإنجليزية",
      fr: "الفرنسية",
      ar: "العربية"
    },

    // Alt Texts and Labels
    altTexts: {
      logo: "تشييد",
      location: "الموقع",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      time: "الوقت",
      facebook: "فيسبوك",
      scrollToTop: "العودة إلى الأعلى"
    },

    // Accessibility Labels
    accessibility: {
      toggleMobileMenu: "تبديل القائمة المحمولة",
      hidePassword: "إخفاء كلمة المرور",
      showPassword: "إظهار كلمة المرور",
      noDate: "لا يوجد تاريخ"
    },

    // Statistics
    statistics: {
      yearsExperience: "سنوات من الخبرة",
      projectsCompleted: "مشاريع مكتملة",
      trustedPartners: "شركاء موثوقون",
      clientSatisfaction: "رضا العملاء"
    },
    showMore: "عرض المزيد",
  },
};
